<ng-template [ngIf]="media" [ngIfThen]="list" [ngIfElse]="loading"></ng-template>

<button
  mat-fab
  color="accent"
  class="mat-add-button"
  *ngIf="canAdd"
  [matTooltip]="'common.addMedia' | t"
  matTooltipPosition="before"
  (click)="add()"
>
  <sn-icon class="add-icon">add</sn-icon>
</button>

<ng-template #list>
  <sn-location-media-list [media]="media" (fileDeleted)="deleteItem($event)">
  </sn-location-media-list>
</ng-template>

<ng-template #loading>
  <mat-spinner [diameter]="48" [strokeWidth]="4" color="accent"></mat-spinner>
</ng-template>
